// @flow
import React, { Component } from 'react';
import Modal from 'app/common/react/ui/Modal';
import PropTypes from 'prop-types';

type State = { modals: Array<Object> };
type Props = { children?: any };

type ModalType = {|
  accessibilityCloseLabel: string,
  accessibilityModalLabel: string,
  children: ?any,
  heading: string,
  footer?: any,
  onDismiss: () => void,
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  undismissible?: boolean,
|};

let identifier = 0;
const getIdentifier = () => (identifier += 1);

class LegacyModalProvider extends Component<Props, State> {
  state: State = {
    modals: [],
  };

  getChildContext() {
    return {
      legacyShowInModal: this.showInModal,
      legacyRemoveModal: this.removeModal,
      legacyClearAllModals: this.clearAllModals,
      legacyUpdateModal: this.updateModal,
    };
  }

  normalizeModal = (options: Object, id: number) => ({
    id,
    props: {
      ...options,
      onDismiss: () => {
        if (!options.undismissible) {
          if (options.onDismiss) {
            options.onDismiss();
          }
          this.removeModal(id);
        }
      },
    },
  });

  showInModal = (options: ModalType) => {
    const id = getIdentifier();
    const modal = this.normalizeModal(options, id);
    this.setState({
      modals: this.state.modals.concat(modal),
    });
    return id;
  };

  removeModal = (id?: number) => {
    const { modals } = this.state;
    const modalId = id || modals[modals.length - 1].id;
    this.setState({
      modals: modals.filter((modal) => modal.id !== modalId),
    });
  };

  clearAllModals = () => {
    this.setState({ modals: [] });
  };

  updateModal = (modalId: number, options: Object) => {
    for (let i = 0; i < this.state.modals.length; i += 1) {
      const modal = this.state.modals[i];
      if (modal.id === modalId) {
        const modals = this.state.modals.slice();
        modals[i] = this.normalizeModal(options, modalId);
        this.setState({ modals });
        return;
      }
    }
  };

  render() {
    // Only show the last modal added...for now
    const modal = this.state.modals[this.state.modals.length - 1];
    return (
      <div>
        {this.props.children}
        {modal && <Modal key={modal.id} {...modal.props} />}
      </div>
    );
  }
}

export const ModalContextTypes = {
  legacyShowInModal: PropTypes.func.isRequired,
  legacyRemoveModal: PropTypes.func.isRequired,
  legacyClearAllModals: PropTypes.func.isRequired,
  legacyUpdateModal: PropTypes.func.isRequired,
};

LegacyModalProvider.childContextTypes = ModalContextTypes;

LegacyModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LegacyModalProvider;
